import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import type { EmailAddressFormProps } from './EmailAddressSettingForm'
import { EmailAddressSettingForm } from './EmailAddressSettingForm'
import type { EmailAddressFormSNSProps } from './EmailAddressSettingFormSNS'
import { EmailAddressSettingFormSNS } from './EmailAddressSettingFormSNS'

export * from './fragments'

export type State = {
  email: string
  isBoundWithSNS: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  updateEmail: EmailAddressFormProps['onSubmit']
  sendVerificationMail: EmailAddressFormSNSProps['onSubmit']
}

export const EmailAddressSettingsTemplate: Template<State, Action> = ({
  state,
  updateEmail,
  sendVerificationMail,
}) => {
  const { t } = useTranslation('emailAddressSettings')
  const { routerNames, routerPages } = useRouter()

  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.AccountSetting,
      }}
    >
      <Head title={routerNames.EmailSetting} />
      {state.isBoundWithSNS ? (
        <EmailAddressSettingFormSNS
          state={state}
          onSubmit={sendVerificationMail}
        />
      ) : (
        <EmailAddressSettingForm state={state} onSubmit={updateEmail} />
      )}
    </BaseLayout>
  )
}
